import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { Toast } from 'vant';
import { Icon } from 'vant';
import 'vant/lib/index.css';
Vue.use(Icon);

Vue.prototype.$toast = Toast;

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
